import { render, staticRenderFns } from "./drawerUpdateStaff.vue?vue&type=template&id=9482d400&scoped=true&"
import script from "./drawerUpdateStaff.vue?vue&type=script&lang=js&"
export * from "./drawerUpdateStaff.vue?vue&type=script&lang=js&"
import style0 from "./drawerUpdateStaff.vue?vue&type=style&index=0&id=9482d400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482d400",
  null
  
)

export default component.exports